"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { Button } from "@/components/button";

export default function GlobalError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="fa" dir="rtl">
      <body>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            fontFamily: "IRANSansX, sans-serif",
          }}
        >
          <h2>خطایی رخ داده است</h2>
          <Button
            variant="bare"
            type="button"
            text="تلاش مجدد"
            onClick={() => reset()}
          />
        </div>
      </body>
    </html>
  );
}
